export default "__VITE_ASSET__U8wMuay5__"